import React, { useEffect, useState } from "react"

import { useTranslation } from "gatsby-plugin-react-i18next"
import { slugMaterialName } from "@utils/helpers"
import { WEBSITE_GENERIC_LANGUAGES } from "@utils/localisation"

import { Link } from "gatsby"

import { useStaticQuery, graphql } from "gatsby"
import { useBreakpoints } from "@hooks/useBreakpoints"

const SingleCountry = ({
  country,
  countryInfo,
  flag,
  language,
  isDisabled = true,
  sluggedMaterialName,
}) => {
  const { t } = useTranslation()

  const officialLanguage = countryInfo.languageCode
  const sluggedcountryName = slugMaterialName(country)

  const classNames = `flex
    items-center
    gap-[8px]
    desk:gap-[16px]
    font-inter
    text-[20px]
    font-normal
    not-italic
    leading-[40px]
    text-dblue 
    h-[24px]
    
    md:w-[162px]

    desk:w-[auto]
  `

  const imgClassNames = `w-[30px] h-[20px] desk:w-[36px] desk:h-[24px] ${
    isDisabled ? "opacity-20" : ""
  }`

  const spanClassNames = `h-[24px] leading-[20px] md:leading-[16px] text-14 desk:text-20 desk:leading-[20px] ${
    isDisabled ? "opacity-20" : ""
  }`

  if (isDisabled) {
    return (
      <div className={classNames}>
        <img className={imgClassNames} src={flag} alt={t(country)} />
        <span className={spanClassNames}>{t(country)}</span>
      </div>
    )
  }

  const getFixedLinkPart = () => {
    return (
      "/scrap-metal-price/" +
      sluggedcountryName +
      (sluggedMaterialName ? `/${sluggedMaterialName}` : "")
    )
  }

  const getLink = () => {
    if (!WEBSITE_GENERIC_LANGUAGES.includes(officialLanguage))
      return `/${officialLanguage}${getFixedLinkPart()}`

    if (WEBSITE_GENERIC_LANGUAGES.includes(language))
      return (language !== "en" ? `/${language}` : "") + getFixedLinkPart()

    return getFixedLinkPart()
  }

  return (
    <div>
      <Link to={getLink()} className={classNames}>
        <img className={imgClassNames} src={flag} alt={t(country)} />
        <span className={spanClassNames}>{t(country)}</span>
      </Link>
    </div>
  )
}

export default ({
  availableCountries,
  allCountries,
  language,
  sluggedMaterialName,
  hideTitle = false,
  hideDescription = false,
}) => {
  const { t } = useTranslation()
  const { isMobile, isTablet } = useBreakpoints()

  // Delete international and order by alphabetical

  const objCountries = allCountries
    .map(country => country.name)
    .filter(obj => obj !== "International")
    .sort()

  function generateOrder(step) {
    const n = objCountries.length
    const result = []
    let index = 0
    let count = 1
    for (let i = 0; i < n; i++) {
      result.push(objCountries[index])
      index = index + step
      if (index >= n) {
        index = count
        count++
      }
    }

    return result
  }

  const [listOfCountries, setListOfCountries] = useState(generateOrder(7))

  useEffect(() => {
    if (isMobile) {
      setListOfCountries(generateOrder(11))
    } else if (isTablet) {
      setListOfCountries(generateOrder(4))
    } else {
      setListOfCountries(generateOrder(7))
    }
  }, [isMobile, isTablet])

  const { allCountryList } = useStaticQuery(graphql`
    query {
      allCountryList {
        nodes {
          en
          flags
        }
      }
    }
  `)

  const filteredCountries = allCountryList.nodes.filter(obj =>
    objCountries.includes(obj.en)
  )

  return (
    <div
      className={`
        bg-white
        flex
        align-center
        justify-center
        

        ml-2

        pt-[40px]
        pb-[40px]

        desk:pt-[100px]
        desk:pb-[100px]`}
    >
      <div
        className={`
          md:max-w-[680px]
          desk:max-w-[960px]
        `}
      >
        {!hideTitle && (
          <span
            className={`
            text-dblue
            font-inter
            block
            mb-[26px]
            text-20

          
            font-medium
            not-italic
            leading-[120%]
            desk:leading-normal
            
            desk:mb-[68px]
            desk:text-[40px]
            `}
          >
            {t("scrap_metal_price_by_country")}
          </span>
        )}
        {!hideDescription && (
          <p
            className={`
            text-bcoral
            font-inter
            text-[20px]
            font-normal
            not-italic
            leading-[30px]
            mb-[58px]
            hidden
               

             desk:block
            `}
          >
            {t("list_of_countries_description")}
          </p>
        )}
        <div
          className={`flex
          w-full
          items-center
          justify-center`}
        >
          <div
            className={`
              grid
              grid-cols-2
              md:grid-cols-4

              
              gap-[11px]
              w-full
              
              desk:grid-cols-3
              desk:gap-[16px]
              desk:max-h-[450px]
              desk:max-w-[845px]
              `}
          >
            {listOfCountries.map(country => {
              const countryInfo = filteredCountries.find(
                obj => obj.en === country
              )
              const completeCountryInfo = allCountries.find(
                obj => obj.name === country
              )

              return (
                <SingleCountry
                  key={country}
                  country={country}
                  language={language}
                  countryInfo={completeCountryInfo}
                  flag={countryInfo.flags}
                  isDisabled={
                    availableCountries
                      .map(country => country.name.common)
                      .indexOf(country) === -1
                  }
                  sluggedMaterialName={sluggedMaterialName}
                />
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
